"use strict";

var _interopRequireDefault = require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.array.find");
require("core-js/modules/web.dom.iterable");
var _objectSpread2 = _interopRequireDefault(require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime-corejs2/helpers/objectSpread2.js"));
require("core-js/modules/es7.array.includes");
require("core-js/modules/es6.string.includes");
var _regenerator2 = _interopRequireDefault(require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime-corejs2/helpers/regenerator.js"));
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));
require("core-js/modules/es6.regexp.split");
require("core-js/modules/es6.regexp.to-string");
require("core-js/modules/es6.regexp.replace");
require("core-js/modules/es6.number.constructor");
var _member = require("@/api/member/member");
var _AccountDetails = _interopRequireDefault(require("../components/AccountDetails.vue"));
var _InformationChangePopup = _interopRequireDefault(require("../components/InformationChangePopup.vue"));
var _BonusPaymentRecordsPopup = _interopRequireDefault(require("./BonusPaymentRecordsPopup.vue"));
var _memberBalanceDetails = require("@/api/financialManagement/memberBalanceDetails");
var _TipsPopup = _interopRequireDefault(require("./TipsPopup.vue"));
var _labelManagement = require("@/api/member/labelManagement");
var _MaturityDate = _interopRequireDefault(require("./components/MaturityDate.vue"));
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'GeneralSituation',
  components: {
    AccountDetails: _AccountDetails.default,
    InformationChangePopup: _InformationChangePopup.default,
    BonusPaymentRecordsPopupCopy: _BonusPaymentRecordsPopup.default,
    TipsPopup: _TipsPopup.default,
    MaturityDate: _MaturityDate.default
  },
  props: {
    memberId: {
      type: Number,
      default: null
    }
  },
  data: function data() {
    return {
      realBoole: false,
      visibles: false,
      dataObj: {},
      details: {},
      regions: {},
      optionsVal: '',
      // 编辑弹窗
      dialogVisible: false,
      // 修改等级或者邀请码*******************************
      editOptions: [],
      MinimumLevel: 0,
      editData: {
        value: '',
        // 修改值
        duration: '',
        // 时长
        remark: '',
        // 修改原因
        type: 1 // 修改类型[1:自购等级、2:邀请码]
      },
      // 解绑弹窗(拼多读，淘宝)*************************
      untieDialog: false,
      platform: '',
      // 平台类型
      // 编辑区域************************************
      // regionalInformation: false,
      isAll: 0,
      // 是否要绑定总代
      regionDataList: {
        firstRegionCodeData: [],
        firstRegionCode: '',
        //	省份code
        secondRegionCodeData: [],
        secondRegionCode: '',
        // 城市code
        thirdRegionCodeData: [],
        thirdRegionCode: '',
        // 区域code
        agentFullName: '',
        // 区域代理名称
        type: null,
        // 代理类型[0:区域代理，1：总代理]
        generalAgentPhone: '',
        // 手机号
        generalAgent: {},
        // 总代信息
        agentMappings: []
      },
      // 扣除
      ruleForm: {
        region: '',
        accountType: '',
        money: '',
        reson: ''
      },
      options_real: [{
        value: 0,
        label: '未认证'
      }, {
        value: 1,
        label: '已认证'
      }],
      ruleForm_real: {
        realName: '',
        accountNumber: '',
        idCardNumber: '',
        reason: '',
        faceAuthStatus: ''
      },
      rules_real: {
        faceAuthStatus: [{
          required: true,
          message: '请选择认证状态',
          trigger: 'change'
        }],
        reason: [{
          required: true,
          message: '请输入操作原因',
          trigger: 'blur'
        }]
      },
      rules: {
        region: [{
          required: true,
          message: '请选择业务类型',
          trigger: 'change'
        }],
        accountType: [{
          required: true,
          message: '请选择账户类型',
          trigger: 'change'
        }],
        money: [{
          required: true,
          message: '请输入金额',
          trigger: 'blur'
        }, {
          validator: function validator(rule, value, callback) {
            if (value === '' || value === null || isNaN(value)) {
              callback(new Error('金额必须为数字'));
            } else {
              callback();
            }
          },
          trigger: 'blur'
        }],
        reson: [{
          required: true,
          message: '请输入内容',
          trigger: 'blur'
        }]
      },
      logType: [],
      teamBalance: null,
      selfBalance: null,
      // 用户身份
      areaData: false,
      targetIdentity: null,
      regionalSetting: false,
      regionalQuery: 1,
      remarkVal: '',
      isRemark: false,
      // 是否显示备注弹窗
      phoneVal: '',
      isPhone: false,
      // 是否显示编辑手机号码弹窗
      ruleForm1: {
        targetPhone: '',
        reason: ''
      },
      rules1: {
        targetPhone: [{
          required: true,
          message: '请输入手机号',
          trigger: 'blur'
        }, {
          pattern: /^1[3-9]\d{9}$/,
          message: '请输入正确的手机号',
          trigger: 'blur'
        }],
        reason: [{
          required: true,
          message: '请输入修改原因',
          trigger: 'blur'
        }]
      },
      isLabel: false,
      allLabels: [],
      hasLabels: [],
      labValue: [],
      Fill: '-',
      // 空白填充
      platformName: {
        PDD: '拼多多',
        TB: '淘宝',
        WPH: '唯品会'
      },
      memberChainLimitVo: {
        tbLimit: null,
        jdLimit: true,
        pddLimit: true,
        wphLimit: true,
        dyLimit: true
      },
      isShowTime: false
    };
  },
  created: function created() {
    this.loadBalance('teamBalance');
    this.loadBalance('selfBalance');
    this.queryMemberAgentRegionApi();
    this.queryRegionListApi();
    this.memberLabels();
  },
  mounted: function mounted() {
    this.memberQueryMemberDetailApi();
    this.memberQueryMemberGradeApi();
    this.queryMemberUpdateLogType();
  },
  methods: {
    changeEditDataVal: function changeEditDataVal(e) {
      if (e === this.MinimumLevel) {
        this.editData.duration = '6';
      }
    },
    // ensure only numeric characters are entered for money field
    onMoneyInput: function onMoneyInput(val) {
      // Vue's number modifier may convert to number; treat as string and strip non-digits
      // const clean = val && val.toString().replace(/[^\d.]/g, '')
      // this.ruleForm.money = clean === '' ? '' : Number(clean)
      var clean = val && val.toString().replace(/[^\d.]/g, '');
      // 限制只能有一个小数点
      var parts = clean.split('.');
      if (parts.length > 2) {
        parts.pop();
      }
      this.ruleForm.money = parts.join('.');
    },
    onTimeRefresh: function onTimeRefresh() {
      this.memberQueryMemberDetailApi();
    },
    onEditTime: function onEditTime(gradeInvalidTime) {
      this.$refs.maturityDate.open(gradeInvalidTime, this.memberId);
    },
    changeLimit: function changeLimit(platform, type) {
      var _this = this;
      console.log(platform, type);
      this.$confirm('确认当前操作？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        _this.editChainLimit(platform, type);
      }).catch(function () {
        // this.$message({
        //   type: 'info',
        //   message: '已取消'
        // })
      });
    },
    editChainLimit: function () {
      var _editChainLimit2 = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee(platform, type) {
        var params, res;
        return (0, _regenerator2.default)().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              params = {
                memberId: this.memberId,
                channel: platform,
                allow: type
              };
              _context.n = 1;
              return (0, _member.editChainLimit)(params);
            case 1:
              res = _context.v;
              console.log('res----', res);
              if (res.code === 0) {
                this.$notify.success({
                  title: '温馨提示',
                  message: '操作成功'
                });
                this.memberQueryMemberDetailApi();
              }
            case 2:
              return _context.a(2);
          }
        }, _callee, this);
      }));
      function editChainLimit(_x, _x2) {
        return _editChainLimit2.apply(this, arguments);
      }
      return editChainLimit;
    }(),
    memberLabels: function () {
      var _memberLabels2 = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee2() {
        var params, res;
        return (0, _regenerator2.default)().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              params = {
                memberId: this.memberId
              };
              _context2.n = 1;
              return (0, _labelManagement.memberLabels)(params);
            case 1:
              res = _context2.v;
              if (res.code === 0) {
                this.hasLabels = res.data.hasLabels;
                this.allLabels = res.data.allLabels || [];
                this.labValue = this.hasLabels.map(function (item) {
                  return item.labelName;
                });
              }
            case 2:
              return _context2.a(2);
          }
        }, _callee2, this);
      }));
      function memberLabels() {
        return _memberLabels2.apply(this, arguments);
      }
      return memberLabels;
    }(),
    onEditArea: function onEditArea(value) {
      this.areaData = true;
      this.targetIdentity = value;
    },
    areaHandleClose: function areaHandleClose() {
      this.areaData = false;
    },
    onEditRegional: function onEditRegional() {
      this.regionalSetting = true;
      this.queryMemberAgentRegionApi();
    },
    regionalClose: function regionalClose() {
      this.regionalSetting = false;
    },
    // onRegionalVerify() {},
    onAreaVerify: function onAreaVerify() {
      var _this2 = this;
      if (this.targetIdentity === null) {
        this.$message.error('请选择用户类型');
        return;
      }
      this.$confirm('确认此操作', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        _this2.updateIdentity();
      }).catch(function () {
        _this2.$message({
          type: 'info',
          message: '已取消'
        });
      });
    },
    queryMemberUpdateLogType: function queryMemberUpdateLogType() {
      var _this3 = this;
      (0, _member.getMemberUpdateLogType)().then(function (res) {
        _this3.logType = res.data;
      });
    },
    loadBalance: function () {
      var _loadBalance2 = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee3(value) {
        var params, res;
        return (0, _regenerator2.default)().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              params = {
                memberId: this.memberId,
                incomeType: value === 'teamBalance' ? 'team' : 'self'
              };
              _context3.n = 1;
              return (0, _memberBalanceDetails.loadBalance)(params);
            case 1:
              res = _context3.v;
              if (res.code === 0) {
                this[value] = res.data.balance;
              }
            case 2:
              return _context3.a(2);
          }
        }, _callee3, this);
      }));
      function loadBalance(_x3) {
        return _loadBalance2.apply(this, arguments);
      }
      return loadBalance;
    }(),
    // 编辑自购等级and邀请码**********************************************************
    // 关闭编辑弹窗
    handleClose: function handleClose() {
      this.editData = {
        value: '',
        // 修改值
        duration: '',
        // 时长
        remark: '',
        // 修改原因
        type: 1 // 修改类型[1:自购等级、2:邀请码]
      };
      this.dialogVisible = false;
    },
    // 确认修改
    onVerify: function onVerify() {
      var _this4 = this;
      if (this.editData.type === 1) {
        if (!this.editData.duration) {
          this.$message.error('请选择时长');
          return;
        }
      }
      if (this.editData.type === 2) {
        if (!this.editData.value) {
          this.$message.error('自定义邀请码不能为空');
          return;
        }
        if (this.editData.value.length !== 6) {
          this.$message.error('自定义邀请码必须为6位');
          return;
        }
        if (this.editData.value.includes(' ')) {
          this.$message.error('自定义邀请码中间不能包含空格');
          return;
        }
      }
      if (!this.editData.remark) {
        this.$message.error('请输入备注原因');
        return;
      }
      if (this.editData.type === 1) {
        this.$confirm('是否确认此操作?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(function () {
          _this4.editUserGradeAndDurationApi();
        });
        return false;
      }
      if (this.editData.type === 2) {
        this.$confirm('是否确认此操作?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(function () {
          _this4.memberUpdateMemberApi();
        });
        return false;
      }
    },
    // 修改等级
    onEditPurchaseGrade: function onEditPurchaseGrade(value) {
      this.editData.value = value;
      this.editData.type = 1;
      this.dialogVisible = true;
    },
    // 修改邀请码
    onEditCode: function onEditCode(val) {
      this.editData.value = val;
      this.editData.type = 2;
      this.dialogVisible = true;
    },
    // 明细
    onDetail: function onDetail(data, type) {
      // this.$refs.accountDetails.open()
      this.$emit('AccountDetails', type);
    },
    // 用户信息变更记录
    onChangeLog: function onChangeLog() {
      this.$refs.InformationChangePopup.open(this.dataObj.userId);
    },
    //  余额发放/扣除明细
    onBonusPaymentRecords: function onBonusPaymentRecords() {
      this.$refs.BonusPaymentRecordsPopupCopy.open(this.dataObj.userId);
    },
    handleCloseVisibles: function handleCloseVisibles() {
      this.$refs['ruleForm'].resetFields();
      this.visibles = false;
    },
    // 授权解绑*************************************************************
    untieClose: function untieClose() {
      this.untieDialog = false;
    },
    onUntieVerify: function onUntieVerify() {
      this.memberUnbindPlatformAuthApi();
    },
    onUntiePDD: function onUntiePDD() {
      this.platform = 'PDD';
      this.untieDialog = true;
    },
    onUntieWPH: function onUntieWPH() {
      this.platform = 'WPH';
      this.untieDialog = true;
    },
    onUntieTB: function onUntieTB() {
      this.platform = 'TB';
      this.untieDialog = true;
    },
    // 编辑区域*******************************************************************
    regionClose: function regionClose() {
      this.isAll = null;
      this.regionDataList = (0, _objectSpread2.default)((0, _objectSpread2.default)({}, this.regionDataList), {
        firstRegionCode: '',
        //	省份code
        secondRegionCodeData: [],
        secondRegionCode: '',
        // 城市code
        thirdRegionCodeData: [],
        thirdRegionCode: '',
        // 区域code
        agentFullName: '',
        // 区域代理名称
        type: null,
        // 代理类型[0:区域代理，1：总代理]
        generalAgentPhone: '' // 手机号
      });
      this.regionalSetting = false;
    },
    // 选择省
    getCity: function getCity() {
      this.regionDataList.secondRegionCode = '';
      this.regionDataList.thirdRegionCode = '';
      this.regionDataList.agentFullName = '';
      this.queryRegionListApi(2, this.regionDataList.firstRegionCode);
    },
    // 选择市
    getRegion: function getRegion() {
      this.regionDataList.agentFullName = '';
      this.regionDataList.thirdRegionCode = '';
      this.queryRegionListApi(3, this.regionDataList.secondRegionCode);
    },
    getArea: function getArea(value) {
      var _this5 = this;
      this.regionDataList.thirdRegionCodeData.forEach(function (item) {
        if (item.regionCode === value) {
          _this5.regionDataList.agentFullName = item.fullName;
        }
      });
    },
    // 确认
    onUpdateUserRegion: function onUpdateUserRegion() {
      var _this6 = this;
      if (this.regionDataList.type === null) {
        this.$message.error('请选择区域代理类型');
        return;
      }
      if (this.dataObj.region.type === this.regionDataList.type) {
        this.$confirm('是否确认此操作?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(function () {
          _this6.updateMemberRegionApi();
        });
      } else {
        if (this.dataObj.region.type === 0 || this.dataObj.region.type === 1) {
          var sf;
          var mb = this.regionDataList.type === 0 ? '区域代理' : '区域总代理';
          if (this.dataObj.region.type === 0) {
            sf = '区域代理';
          } else if (this.dataObj.region.type === 1) {
            sf = '区域总代理';
          } else {
            sf = '';
          }
          this.$confirm("\u5F53\u524D\u7528\u6237\u4E3A".concat(sf, "\uFF0C\u8BBE\u7F6E\u4E3A").concat(mb, "\u540E\uFF0C\u4E4B\u524D\u7ED1\u5B9A\u7684\u533A\u57DF\u4FE1\u606F\u5C06\u5931\u6548\uFF0C\u8BF7\u8C28\u614E\u64CD\u4F5C!"), '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(function () {
            _this6.updateMemberRegionApi();
          });
        } else {
          this.$confirm('确定设置当前用户代理身份?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(function () {
            _this6.updateMemberRegionApi();
          });
        }
        // if (this.regionDataList.type === 0) {
        //   this.$confirm('当前用户为区域总代理，设置为区域代理后，之前绑定的区域信息将失效，请谨慎操作!', '提示', {
        //     confirmButtonText: '确定',
        //     cancelButtonText: '取消',
        //     type: 'warning'
        //   }).then(() => {
        //     this.updateMemberRegionApi()
        //   })
        // }
        // if (this.regionDataList.type === 1) {
        //   this.$confirm('当前用户为区域代理，设置为区域总代理后，之前绑定的区域信息将失效，请谨慎操作!', '提示', {
        //     confirmButtonText: '确定',
        //     cancelButtonText: '取消',
        //     type: 'warning'
        //   }).then(() => {
        //     this.updateMemberRegionApi()
        //   })
        // }
      }
    },
    // 是否设置为推广客
    onChangeSwitch: function onChangeSwitch(val) {
      var _this7 = this;
      // this.updateMemberPromotion(val ? 1 : 0)
      if (val) {
        this.$confirm('是否设置为推广客?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(function () {
          _this7.updateMemberPromotion(1);
        });
      } else {
        this.$confirm('是否确认取消推广客?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(function () {
          _this7.updateMemberPromotion(0);
        });
      }
    },
    // 设置为推广客
    updateMemberPromotion: function () {
      var _updateMemberPromotion2 = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee4(promotion) {
        var params, res, _t;
        return (0, _regenerator2.default)().w(function (_context4) {
          while (1) switch (_context4.p = _context4.n) {
            case 0:
              _context4.p = 0;
              params = {
                memberId: this.memberId,
                promotion: promotion
              };
              _context4.n = 1;
              return (0, _member.updateMemberPromotion)(params);
            case 1:
              res = _context4.v;
              if (res.code === 0) {
                this.$notify.success({
                  title: '温馨提示',
                  message: '操作成功'
                });
                this.memberQueryMemberDetailApi();
              }
              _context4.n = 3;
              break;
            case 2:
              _context4.p = 2;
              _t = _context4.v;
              console.log(_t);
            case 3:
              return _context4.a(2);
          }
        }, _callee4, this, [[0, 2]]);
      }));
      function updateMemberPromotion(_x4) {
        return _updateMemberPromotion2.apply(this, arguments);
      }
      return updateMemberPromotion;
    }(),
    // 取消总代/区代身份
    onCancelRegion: function onCancelRegion() {
      var _this8 = this;
      this.$confirm('是否确定取消该用户的代理身份？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        _this8.regionDataList.type = 2;
        _this8.updateMemberRegionApi();
      });
    },
    // 失效当前用户
    onLoseEffectivenessUser: function onLoseEffectivenessUser() {
      var _this9 = this;
      this.$confirm('是否确认失效此用户?失效操作将消除账号原有信息，用户需重新注册，请谨慎操作!', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        _this9.memberDisableApi();
      }).catch(function () {
        _this9.$message({
          type: 'info',
          message: '已取消'
        });
      });
    },
    // 锁定当前用户
    onLockUser: function onLockUser() {
      var _this0 = this;
      this.$confirm('确认禁止当前用户进行提现操作？请谨慎操作!', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        _this0.updateMemberStatusApi(1);
      }).catch(function () {
        _this0.$message({
          type: 'info',
          message: '已取消'
        });
      });
    },
    // 解锁锁定用户
    onUnlockUser: function onUnlockUser() {
      var _this1 = this;
      this.$confirm('是否确认解锁当前用户?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        _this1.updateMemberStatusApi(0);
      }).catch(function () {
        _this1.$message({
          type: 'info',
          message: '已取消'
        });
      });
    },
    // 加入黑名单
    onJoinBlacklist: function onJoinBlacklist() {
      var _this10 = this;
      this.$confirm('是否确认加入黑名单?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        _this10.addOrCancelBlacklistApi(1);
      }).catch(function () {
        _this10.$message({
          type: 'info',
          message: '已取消'
        });
      });
    },
    // 取消黑名单
    onCancelBlacklist: function onCancelBlacklist() {
      var _this11 = this;
      this.$confirm('是否确认取消黑名单?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        _this11.addOrCancelBlacklistApi(0);
      }).catch(function () {
        _this11.$message({
          type: 'info',
          message: '已取消'
        });
      });
    },
    // 接口调用 ********************************************************************
    // 详情
    memberQueryMemberDetailApi: function () {
      var _memberQueryMemberDetailApi2 = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee5() {
        var params, res, _t2;
        return (0, _regenerator2.default)().w(function (_context5) {
          while (1) switch (_context5.p = _context5.n) {
            case 0:
              _context5.p = 0;
              params = {
                memberId: this.memberId
              };
              _context5.n = 1;
              return (0, _member.memberQueryMemberDetailApi)(params);
            case 1:
              res = _context5.v;
              if (res.code === 0) {
                this.dataObj = res.data;
                this.memberChainLimitVo = res.data.detail.memberChainLimitVo;
                this.details = res.data.detail;
                this.regions = res.data.region;
              }
              _context5.n = 3;
              break;
            case 2:
              _context5.p = 2;
              _t2 = _context5.v;
              console.log(_t2);
            case 3:
              return _context5.a(2);
          }
        }, _callee5, this, [[0, 2]]);
      }));
      function memberQueryMemberDetailApi() {
        return _memberQueryMemberDetailApi2.apply(this, arguments);
      }
      return memberQueryMemberDetailApi;
    }(),
    // 修改接口
    memberUpdateMemberApi: function () {
      var _memberUpdateMemberApi2 = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee6() {
        var params, res, _t3;
        return (0, _regenerator2.default)().w(function (_context6) {
          while (1) switch (_context6.p = _context6.n) {
            case 0:
              _context6.p = 0;
              params = (0, _objectSpread2.default)({
                memberId: this.memberId
              }, this.editData);
              _context6.n = 1;
              return (0, _member.memberUpdateMemberApi)(params);
            case 1:
              res = _context6.v;
              if (res.code === 0) {
                this.$notify.success({
                  title: '温馨提示',
                  message: '操作成功'
                });
                this.memberQueryMemberDetailApi();
                this.handleClose();
                this.editData = {
                  value: '',
                  // 修改值
                  duration: '',
                  // 时长
                  remark: '',
                  // 修改原因
                  type: 1 // 修改类型[1:自购等级、2:邀请码]
                };
              } else {
                this.$notify.success({
                  title: '温馨提示',
                  message: '操作失败'
                });
              }
              _context6.n = 3;
              break;
            case 2:
              _context6.p = 2;
              _t3 = _context6.v;
              console.log(_t3);
            case 3:
              return _context6.a(2);
          }
        }, _callee6, this, [[0, 2]]);
      }));
      function memberUpdateMemberApi() {
        return _memberUpdateMemberApi2.apply(this, arguments);
      }
      return memberUpdateMemberApi;
    }(),
    editUserGradeAndDurationApi: function () {
      var _editUserGradeAndDurationApi = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee7() {
        var params, res, _t4;
        return (0, _regenerator2.default)().w(function (_context7) {
          while (1) switch (_context7.p = _context7.n) {
            case 0:
              _context7.p = 0;
              params = {
                memberId: this.memberId,
                reason: this.editData.remark,
                duration: Number(this.editData.duration),
                targetGrade: this.editData.value
              };
              _context7.n = 1;
              return (0, _member.editUserGradeAndDuration)(params);
            case 1:
              res = _context7.v;
              if (res.code === 0) {
                this.$notify.success({
                  title: '温馨提示',
                  message: '操作成功'
                });
                this.memberQueryMemberDetailApi();
                this.handleClose();
                this.editData = {
                  value: '',
                  // 修改值
                  duration: '',
                  // 时长
                  remark: '',
                  // 修改原因
                  type: 1 // 修改类型[1:自购等级、2:邀请码]
                };
              } else {
                this.$notify.success({
                  title: '温馨提示',
                  message: '操作失败'
                });
              }
              _context7.n = 3;
              break;
            case 2:
              _context7.p = 2;
              _t4 = _context7.v;
              console.log(_t4);
            case 3:
              return _context7.a(2);
          }
        }, _callee7, this, [[0, 2]]);
      }));
      function editUserGradeAndDurationApi() {
        return _editUserGradeAndDurationApi.apply(this, arguments);
      }
      return editUserGradeAndDurationApi;
    }(),
    // 解除授权
    memberUnbindPlatformAuthApi: function () {
      var _memberUnbindPlatformAuthApi2 = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee8() {
        var params, res, _t5;
        return (0, _regenerator2.default)().w(function (_context8) {
          while (1) switch (_context8.p = _context8.n) {
            case 0:
              _context8.p = 0;
              params = {
                memberId: this.memberId,
                platform: this.platform
              };
              _context8.n = 1;
              return (0, _member.memberUnbindPlatformAuthApi)(params);
            case 1:
              res = _context8.v;
              if (res.code === 0) {
                this.$notify.success({
                  title: '温馨提示',
                  message: '操作成功'
                });
                this.untieClose();
                this.memberQueryMemberDetailApi();
              } else {
                this.$notify.success({
                  title: '温馨提示',
                  message: '操作失败'
                });
              }
              _context8.n = 3;
              break;
            case 2:
              _context8.p = 2;
              _t5 = _context8.v;
              console.log(_t5);
            case 3:
              return _context8.a(2);
          }
        }, _callee8, this, [[0, 2]]);
      }));
      function memberUnbindPlatformAuthApi() {
        return _memberUnbindPlatformAuthApi2.apply(this, arguments);
      }
      return memberUnbindPlatformAuthApi;
    }(),
    // 会员等级列表
    memberQueryMemberGradeApi: function () {
      var _memberQueryMemberGradeApi2 = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee9() {
        var params, res, minGradeObj, _t6;
        return (0, _regenerator2.default)().w(function (_context9) {
          while (1) switch (_context9.p = _context9.n) {
            case 0:
              _context9.p = 0;
              params = {};
              _context9.n = 1;
              return (0, _member.memberQueryMemberGradeApi)(params);
            case 1:
              res = _context9.v;
              if (res.code === 0) {
                minGradeObj = res.data.reduce(function (min, current) {
                  return current.grade < min.grade ? current : min;
                });
                console.log('res.data-------------', minGradeObj);
                this.MinimumLevel = minGradeObj.grade;
                this.editOptions = res.data;
              }
              _context9.n = 3;
              break;
            case 2:
              _context9.p = 2;
              _t6 = _context9.v;
              console.log(_t6);
            case 3:
              return _context9.a(2);
          }
        }, _callee9, this, [[0, 2]]);
      }));
      function memberQueryMemberGradeApi() {
        return _memberQueryMemberGradeApi2.apply(this, arguments);
      }
      return memberQueryMemberGradeApi;
    }(),
    // 查询区域列表
    queryRegionListApi: function () {
      var _queryRegionListApi2 = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee0() {
        var type,
          regionCode,
          params,
          res,
          _args0 = arguments,
          _t7;
        return (0, _regenerator2.default)().w(function (_context0) {
          while (1) switch (_context0.p = _context0.n) {
            case 0:
              type = _args0.length > 0 && _args0[0] !== undefined ? _args0[0] : 1;
              regionCode = _args0.length > 1 ? _args0[1] : undefined;
              _context0.p = 1;
              params = {
                type: type,
                regionCode: regionCode
              };
              _context0.n = 2;
              return (0, _member.queryRegionListApi)(params);
            case 2:
              res = _context0.v;
              if (res.code === 0) {
                if (type === 1) {
                  this.regionDataList.firstRegionCodeData = res.data;
                } else if (type === 2) {
                  this.regionDataList.secondRegionCodeData = res.data;
                } else if (type === 3) {
                  this.regionDataList.thirdRegionCodeData = res.data;
                }
              }
              _context0.n = 4;
              break;
            case 3:
              _context0.p = 3;
              _t7 = _context0.v;
              console.log(_t7);
            case 4:
              return _context0.a(2);
          }
        }, _callee0, this, [[1, 3]]);
      }));
      function queryRegionListApi() {
        return _queryRegionListApi2.apply(this, arguments);
      }
      return queryRegionListApi;
    }(),
    // 查询 查询用户代理区域code
    queryMemberAgentRegionApi: function () {
      var _queryMemberAgentRegionApi2 = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee1() {
        var params, res, _t8;
        return (0, _regenerator2.default)().w(function (_context1) {
          while (1) switch (_context1.p = _context1.n) {
            case 0:
              _context1.p = 0;
              params = {
                memberId: this.memberId
              };
              _context1.n = 1;
              return (0, _member.queryMemberAgentRegionApi)(params);
            case 1:
              res = _context1.v;
              if (res.code === 0) {
                this.regionDataList.type = res.data.type;
                this.regionDataList.agentFullName = res.data.agentFullName;
                this.regionDataList.firstRegionCode = res.data.firstRegionCode;
                this.regionDataList.secondRegionCode = res.data.secondRegionCode;
                this.regionDataList.thirdRegionCode = res.data.thirdRegionCode;
                // 区代
                if (res.data.type === 0) {
                  this.regionDataList.generalAgent = res.data.generalAgent;
                  this.regionDataList.generalAgentPhone = res.data.generalAgent.phone;
                  if (res.data.generalAgent.phone) {
                    this.isAll = 1;
                  } else {
                    this.isAll = 0;
                  }
                }
                if (res.data.type === 1) {
                  this.regionDataList.agentMappings = res.data.agentMappings;
                }
                if (res.data.thirdRegionCode) {
                  this.queryRegionListApi(2, this.regionDataList.firstRegionCode);
                  this.queryRegionListApi(3, this.regionDataList.secondRegionCode);
                }
              }
              _context1.n = 3;
              break;
            case 2:
              _context1.p = 2;
              _t8 = _context1.v;
              console.log(_t8);
            case 3:
              return _context1.a(2);
          }
        }, _callee1, this, [[0, 2]]);
      }));
      function queryMemberAgentRegionApi() {
        return _queryMemberAgentRegionApi2.apply(this, arguments);
      }
      return queryMemberAgentRegionApi;
    }(),
    // 修改用户区域
    updateMemberRegionApi: function () {
      var _updateMemberRegionApi2 = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee10() {
        var params, res, _t9;
        return (0, _regenerator2.default)().w(function (_context10) {
          while (1) switch (_context10.p = _context10.n) {
            case 0:
              _context10.p = 0;
              params = {
                memberId: this.memberId,
                type: this.regionDataList.type,
                regionCode: this.regionDataList.thirdRegionCode,
                generalAgentPhone: this.regionDataList.generalAgentPhone,
                fullName: this.regionDataList.agentFullName
              }; // 选择不绑定
              if (this.isAll === 0) {
                params.generalAgentPhone = '';
              }
              _context10.n = 1;
              return (0, _member.updateMemberRegionApi)(params);
            case 1:
              res = _context10.v;
              if (res.code === 0) {
                this.$notify.success({
                  title: '温馨提示',
                  message: '编辑成功'
                });
                this.memberQueryMemberDetailApi();
                this.regionClose();
                this.queryMemberAgentRegionApi();
              }
              _context10.n = 3;
              break;
            case 2:
              _context10.p = 2;
              _t9 = _context10.v;
              console.log(_t9);
            case 3:
              return _context10.a(2);
          }
        }, _callee10, this, [[0, 2]]);
      }));
      function updateMemberRegionApi() {
        return _updateMemberRegionApi2.apply(this, arguments);
      }
      return updateMemberRegionApi;
    }(),
    // 失效用户
    memberDisableApi: function () {
      var _memberDisableApi2 = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee11() {
        var params, res, _t0;
        return (0, _regenerator2.default)().w(function (_context11) {
          while (1) switch (_context11.p = _context11.n) {
            case 0:
              _context11.p = 0;
              params = {
                memberId: this.memberId
              };
              _context11.n = 1;
              return (0, _member.memberDisableApi)(params);
            case 1:
              res = _context11.v;
              if (res.code === 0) {
                this.$notify.success({
                  title: '温馨提示',
                  message: '操作成功'
                });
                this.memberQueryMemberDetailApi();
              }
              _context11.n = 3;
              break;
            case 2:
              _context11.p = 2;
              _t0 = _context11.v;
              console.log(_t0);
            case 3:
              return _context11.a(2);
          }
        }, _callee11, this, [[0, 2]]);
      }));
      function memberDisableApi() {
        return _memberDisableApi2.apply(this, arguments);
      }
      return memberDisableApi;
    }(),
    // 锁定用户
    updateMemberStatusApi: function () {
      var _updateMemberStatusApi2 = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee12(status) {
        var params, res, _t1;
        return (0, _regenerator2.default)().w(function (_context12) {
          while (1) switch (_context12.p = _context12.n) {
            case 0:
              _context12.p = 0;
              // 状态[0：正常 1：锁定]
              params = {
                memberId: this.memberId,
                status: status
              };
              _context12.n = 1;
              return (0, _member.updateMemberStatusApi)(params);
            case 1:
              res = _context12.v;
              if (res.code === 0) {
                this.$notify.success({
                  title: '温馨提示',
                  message: '操作成功'
                });
                this.memberQueryMemberDetailApi();
              }
              _context12.n = 3;
              break;
            case 2:
              _context12.p = 2;
              _t1 = _context12.v;
              console.log(_t1);
            case 3:
              return _context12.a(2);
          }
        }, _callee12, this, [[0, 2]]);
      }));
      function updateMemberStatusApi(_x5) {
        return _updateMemberStatusApi2.apply(this, arguments);
      }
      return updateMemberStatusApi;
    }(),
    // 更改用户身份
    updateIdentity: function () {
      var _updateIdentity2 = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee13() {
        var params, res, _t10;
        return (0, _regenerator2.default)().w(function (_context13) {
          while (1) switch (_context13.p = _context13.n) {
            case 0:
              _context13.p = 0;
              params = {
                memberId: this.memberId,
                targetIdentity: this.targetIdentity
              };
              _context13.n = 1;
              return (0, _member.updateIdentity)(params);
            case 1:
              res = _context13.v;
              if (res.code === 0) {
                this.$notify.success({
                  title: '温馨提示',
                  message: '操作成功'
                });
                this.areaHandleClose();
                this.memberQueryMemberDetailApi();
              }
              _context13.n = 3;
              break;
            case 2:
              _context13.p = 2;
              _t10 = _context13.v;
              console.log(_t10);
            case 3:
              return _context13.a(2);
          }
        }, _callee13, this, [[0, 2]]);
      }));
      function updateIdentity() {
        return _updateIdentity2.apply(this, arguments);
      }
      return updateIdentity;
    }(),
    // 黑名单
    addOrCancelBlacklistApi: function () {
      var _addOrCancelBlacklistApi2 = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee14(type) {
        var params, res, _t11;
        return (0, _regenerator2.default)().w(function (_context14) {
          while (1) switch (_context14.p = _context14.n) {
            case 0:
              _context14.p = 0;
              params = {
                memberId: this.memberId,
                type: type
              };
              _context14.n = 1;
              return (0, _member.addOrCancelBlacklistApi)(params);
            case 1:
              res = _context14.v;
              if (res.code === 0) {
                this.$notify.success({
                  title: '温馨提示',
                  message: '操作成功'
                });
                this.memberQueryMemberDetailApi();
              }
              _context14.n = 3;
              break;
            case 2:
              _context14.p = 2;
              _t11 = _context14.v;
              console.log(_t11);
            case 3:
              return _context14.a(2);
          }
        }, _callee14, this, [[0, 2]]);
      }));
      function addOrCancelBlacklistApi(_x6) {
        return _addOrCancelBlacklistApi2.apply(this, arguments);
      }
      return addOrCancelBlacklistApi;
    }(),
    openIt: function openIt() {
      var _this12 = this;
      (0, _member.find_account)({
        memberId: this.memberId
      }).then(function (res) {
        _this12.ruleForm_real = (0, _objectSpread2.default)({}, res.data);
        if (res.data === null) {
          _this12.ruleForm_real['memberId'] = _this12.memberId;
        }
        _this12.realBoole = true;
      });
    },
    submitForm_real: function submitForm_real(formName) {
      var _this13 = this;
      this.$refs[formName].validate(function (valid) {
        if (valid) {
          console.log(_this13.ruleForm_real);
          (0, _member.update_account)(_this13.ruleForm_real).then(function (res) {
            if (res.data) {
              _this13.$notify.success({
                title: '温馨提示',
                message: '操作成功'
              });
              _this13.memberQueryMemberDetailApi();
              _this13.realBoole = false;
            }
          });
        } else {
          return false;
        }
      });
    },
    submitForm: function submitForm(formName) {
      var _this14 = this;
      this.$refs[formName].validate(function (valid) {
        if (valid) {
          _this14.$confirm("\u60A8\u5373\u5C06\u8FDB\u884C".concat(_this14.ruleForm.region === 'in' ? '充值' : '扣除', "\u64CD\u4F5C\uFF0C\u91D1\u989D\u4E3A").concat(_this14.ruleForm.money, "\u5143\u3002\u8BF7\u4ED4\u7EC6\u6838\u5BF9\uFF0C\u662F\u5426\u7EE7\u7EED\uFF1F"), '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(function () {
            (0, _member.giveBalance)({
              incomeType: _this14.ruleForm.accountType,
              giveType: _this14.ruleForm.region,
              amount: _this14.ruleForm.money,
              reason: _this14.ruleForm.reson,
              memberId: _this14.memberId
            }).then(function (res) {
              _this14.$notify.success({
                title: '温馨提示',
                message: '操作成功'
              });
              _this14.resetForm('ruleForm');
            });
          }).catch(function () {
            _this14.$message({
              type: 'info',
              message: '已取消'
            });
          });
        } else {
          return false;
        }
      });
    },
    resetForm: function resetForm(formName) {
      this.visibles = false;
      this.$refs[formName].resetFields();
    },
    onUserDetails: function onUserDetails(id, name) {
      this.$router.replace({
        path: '/member/userDetails',
        query: {
          memberId: id,
          nickname: name
        }
      });
      this.$router.go({
        path: '/member/userDetails',
        query: {
          memberId: id,
          nickname: name
        }
      });
    },
    // 撤销注销
    onCancellation: function onCancellation(memberId) {
      var _this15 = this;
      this.$confirm('是否确认恢复当前用户?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        _this15.resetLogoff(memberId);
      }).catch(function () {
        _this15.$message({
          type: 'info',
          message: '已取消'
        });
      });
    },
    resetLogoff: function () {
      var _resetLogoff2 = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee15(memberId) {
        var params, res, _t12;
        return (0, _regenerator2.default)().w(function (_context15) {
          while (1) switch (_context15.p = _context15.n) {
            case 0:
              _context15.p = 0;
              params = {
                memberId: memberId
              };
              _context15.n = 1;
              return (0, _member.resetLogoff)(params);
            case 1:
              res = _context15.v;
              if (res.code === 0) {
                this.$notify.success({
                  title: '温馨提示',
                  message: '操作成功'
                });
                this.memberQueryMemberDetailApi();
              }
              _context15.n = 3;
              break;
            case 2:
              _context15.p = 2;
              _t12 = _context15.v;
              console.log(_t12);
            case 3:
              return _context15.a(2);
          }
        }, _callee15, this, [[0, 2]]);
      }));
      function resetLogoff(_x7) {
        return _resetLogoff2.apply(this, arguments);
      }
      return resetLogoff;
    }(),
    editRemark: function () {
      var _editRemark2 = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee16() {
        var params, res, _t13;
        return (0, _regenerator2.default)().w(function (_context16) {
          while (1) switch (_context16.p = _context16.n) {
            case 0:
              _context16.p = 0;
              params = {
                memberId: this.memberId,
                remark: this.remarkVal
              };
              _context16.n = 1;
              return (0, _member.editRemark)(params);
            case 1:
              res = _context16.v;
              if (res.code === 0) {
                this.$notify.success({
                  title: '温馨提示',
                  message: '操作成功'
                });
                this.memberQueryMemberDetailApi();
                this.isRemark = false;
                this.remarkVal = '';
              }
              _context16.n = 3;
              break;
            case 2:
              _context16.p = 2;
              _t13 = _context16.v;
              console.log(_t13);
            case 3:
              return _context16.a(2);
          }
        }, _callee16, this, [[0, 2]]);
      }));
      function editRemark() {
        return _editRemark2.apply(this, arguments);
      }
      return editRemark;
    }(),
    // 备注
    onEditRemark: function onEditRemark(value) {
      this.isRemark = true;
      this.remarkVal = value;
    },
    onRemarkVerify: function onRemarkVerify() {
      var _this16 = this;
      if (!this.remarkVal) {
        this.$message.error('请输入备注内容');
        return;
      }
      this.$confirm('是否编辑此备注', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        _this16.editRemark();
      }).catch(function () {
        _this16.$message({
          type: 'info',
          message: '已取消'
        });
      });
    },
    RemarkClose: function RemarkClose() {
      this.isRemark = false;
      this.remarkVal = '';
    },
    // 编辑标签
    onEditLabel: function onEditLabel() {
      this.isLabel = true;
      this.memberLabels();
    },
    LabelClose: function LabelClose() {
      this.isLabel = false;
      this.labValue = [];
    },
    onLabelVerify: function onLabelVerify() {
      var _this17 = this;
      // if (this.labValue.length < 1) {
      //   this.$message.error('请选择标签内容')
      //   return
      // }
      this.$confirm('是否操作此标签', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        var params1 = [];
        if (_this17.labValue.length >= 1) {
          _this17.labValue.forEach(function (label) {
            var matchedItem = _this17.allLabels.find(function (item) {
              return item.labelName === label;
            });
            if (matchedItem) {
              params1.push(matchedItem);
            } else {
              params1.push({
                id: null,
                labelName: label
              });
            }
          });
        }
        _this17.attachLabel(params1);
      }).catch(function () {
        _this17.$message({
          type: 'info',
          message: '已取消'
        });
      });
    },
    attachLabel: function () {
      var _attachLabel2 = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee17(memberLabels) {
        var params, res, _t14;
        return (0, _regenerator2.default)().w(function (_context17) {
          while (1) switch (_context17.p = _context17.n) {
            case 0:
              _context17.p = 0;
              params = {
                memberId: this.memberId,
                memberLabels: memberLabels
              };
              _context17.n = 1;
              return (0, _labelManagement.attachLabel)(params);
            case 1:
              res = _context17.v;
              if (res.code === 0) {
                this.$notify.success({
                  title: '温馨提示',
                  message: '操作成功'
                });
                this.isLabel = false;
                this.memberLabels();
              }
              _context17.n = 3;
              break;
            case 2:
              _context17.p = 2;
              _t14 = _context17.v;
              console.log(_t14);
            case 3:
              return _context17.a(2);
          }
        }, _callee17, this, [[0, 2]]);
      }));
      function attachLabel(_x8) {
        return _attachLabel2.apply(this, arguments);
      }
      return attachLabel;
    }(),
    changePhone: function () {
      var _changePhone2 = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee18() {
        var params, res, _t15;
        return (0, _regenerator2.default)().w(function (_context18) {
          while (1) switch (_context18.p = _context18.n) {
            case 0:
              _context18.p = 0;
              params = {
                memberId: this.memberId,
                targetPhone: this.ruleForm1.targetPhone,
                reason: this.ruleForm1.reason
              };
              _context18.n = 1;
              return (0, _member.changePhone)(params);
            case 1:
              res = _context18.v;
              if (res.code === 0) {
                this.$notify.success({
                  title: '温馨提示',
                  message: '操作成功'
                });
                this.resetForm1('ruleForm1');
                this.memberQueryMemberDetailApi();
              }
              _context18.n = 3;
              break;
            case 2:
              _context18.p = 2;
              _t15 = _context18.v;
              console.log(_t15);
            case 3:
              return _context18.a(2);
          }
        }, _callee18, this, [[0, 2]]);
      }));
      function changePhone() {
        return _changePhone2.apply(this, arguments);
      }
      return changePhone;
    }(),
    onEditPhone: function onEditPhone(val) {
      this.isPhone = true;
    },
    phoneClose: function phoneClose() {
      this.resetForm1('ruleForm1');
    },
    submitForm1: function submitForm1(formName) {
      var _this18 = this;
      this.$refs[formName].validate(function (valid) {
        if (valid) {
          _this18.$confirm('是否确认修改此手机号', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(function () {
            _this18.changePhone();
          }).catch(function () {
            _this18.$message({
              type: 'info',
              message: '已取消'
            });
          });
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    resetForm1: function resetForm1(formName) {
      this.isPhone = false;
      this.ruleForm1.targetPhone = '';
      this.ruleForm1.reason = '';
      this.$refs[formName].resetFields();
    }
  }
};